import { Component, OnInit, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UtilityService } from '../../../../services';
import { CommonFieldWidgetBase } from '../common-field-widget-base';
import { CommonPhoneField } from '../field';
import { getLabels } from '../field.labels';


@Component({
	selector: 'common-phone-field',
	imports: [FormsModule],
	templateUrl: './common-phone-field.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	host: { '[class.d-none]': 'isExcluded()' },
})
export class CommonPhoneFieldWidget extends CommonFieldWidgetBase<string, CommonPhoneField> implements OnInit {

	private util = inject(UtilityService);
	public readonly field = input.required<CommonPhoneField>();

	public readonly labels = computed(() => getLabels(this.field().config().isSpanish));


	public readonly renderedModel = computed(() => {
		const value = this.field().pendingValue() ?? this.field().actualValue();
		return this.render(value);
	});


	private phonePatternUS = /^(?:\+1)?\s?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;


	ngOnInit() {
		this.onInit(this.field());
	}


	public onChange(value: string) {
		this.processChange(value);
	}


	public async onBlur() {
		await this.processBlur();
	}


	protected override cleanValue(value: string): string {
		let n = value.replace(/\D/g, '');
		if (n.length && n[0] == '1') n = n.slice(1);
		if (n.length == 10) return '+1' + n;
		else return '';
	}


	protected override render(value: string) {
		if (this.hasFocus() || this.error()) return value;
		return this.util.phone.format(value);
	}


	protected validate(value: string): string {

		const config = this.field().config();
		const labels = this.labels();

		if (value.length == 0 && config.isRequired) return labels.missingRequired();
		if (value.length && !value.match(this.phonePatternUS)) return labels.notValidPhonePattern();

		return '';
	}


	public setFocus() {
		console.error('setFocus() not implemented');
	}
	
}